import { takeLatest, call, put } from 'redux-saga/effects'

import externalCoursesEnrolledList, {
  GetListResponse,
} from 'api/externalCoursesEnrolled/List'
import {
  EXTERNAL_COURSE_ENROLLED_GET_LIST,
  Actions,
  ExternalCoursesEnrolledListPayload,
} from '../../actions/externalCoursesEnrolled.action'
import { ActionWithPayload } from '../../../helpers/redux-actions.helper'

const pattern = EXTERNAL_COURSE_ENROLLED_GET_LIST

export type ExternalCoursesEnrolledListAction = ActionWithPayload<
  typeof pattern,
  ExternalCoursesEnrolledListPayload
>

function* externalCoursesEnrolledListEffectSaga(
  action: ExternalCoursesEnrolledListAction
) {
  try {
    const { params } = action.payload
    const { page, state, searchText, sort, perPage } = params

    const {
      data,
      total,
      perPage: resPerPage,
    }: GetListResponse = yield call(externalCoursesEnrolledList, {
      page,
      searchText,
      sort,
      perPage,
      state,
    })
    yield put(Actions.setListSuccess(data, total, resPerPage, sort))
  } catch (error) {
    console.error('error: ', error)
    yield put(Actions.setLoading(false))
  }
}

export function* externalCoursesEnrolledListWatcherSaga() {
  yield takeLatest(pattern, externalCoursesEnrolledListEffectSaga)
}
